// baseurl.js

// Backend API base URL
export const baseurl = "https://subcity.evventoz.com/api/"; 
// export const baseurl = "http://localhost:5000/api/"; 

// Image base URL (for static uploads)
export const imgurl = "https://subcity.evventoz.com/"; 
